// covered-by: frontends/carrie/src/routes/ask-puntt/components/__tests__/ChatThreadArtifactCards.test.tsx
import { ArtifactListCard } from "./ArtifactListCard";
import { ReviewListCard } from "./ReviewListCard";

import {
  type ChatArtifact,
  type ChatArtifactOpenPayload,
} from "../artifactTypes";

/**
 * Inline artifact openers in the chat thread — same ReviewListCard /
 * ArtifactListCard affordance as the cowork sidebar. Each instance renders
 * the artifact(s) anchored to a single message.
 */
export function ChatThreadArtifactCards({
  artifacts,
  anchorMessageId,
  isArtifactActive,
  onOpenArtifact,
  isArtifactUnread,
}: {
  artifacts: readonly ChatArtifact[];
  anchorMessageId: string;
  isArtifactActive: (artifact: ChatArtifact) => boolean;
  onOpenArtifact: (payload: ChatArtifactOpenPayload) => void;
  isArtifactUnread?: (artifact: ChatArtifact) => boolean;
}) {
  if (artifacts.length === 0) return null;

  return (
    <div
      className="mt-3 flex flex-col gap-2"
      data-testid={`chat-thread-artifact-cards-${anchorMessageId}`}
      aria-label="Open review or document"
    >
      {artifacts.map((artifact) =>
        artifact.kind === "review" ? (
          <ReviewListCard
            key={artifact.id}
            data-testid={`chat-thread-artifact-row-${artifact.id}`}
            testIdPrefix="chat-thread-artifact-row"
            isActive={isArtifactActive(artifact)}
            hasUnread={isArtifactUnread?.(artifact) ?? false}
            unreadTestId={`chat-thread-artifact-unread-${artifact.id}`}
            item={{
              id: artifact.id,
              name: artifact.title,
              versionNumber: artifact.versionNumber,
              thumbnailUrl: artifact.thumbnailUrl,
              aiCommentCount: artifact.aiCommentCount,
              humanCommentCount: artifact.humanCommentCount,
              isGenerating: artifact.isGenerating,
            }}
            onClick={() => {
              if (artifact.ticketId && !artifact.isGenerating) {
                onOpenArtifact({
                  kind: "review",
                  ticketId: artifact.ticketId,
                });
              }
            }}
          />
        ) : (
          <ArtifactListCard
            key={artifact.id}
            artifact={artifact}
            isActive={isArtifactActive(artifact)}
            hasUnread={isArtifactUnread?.(artifact) ?? false}
            unreadTestId={`chat-thread-artifact-unread-${artifact.id}`}
            testIdPrefix="chat-thread-artifact-row"
            data-testid={`chat-thread-artifact-row-${artifact.id}`}
            onClick={() => {
              onOpenArtifact({
                kind: "canvas",
                messageId: artifact.messageId,
              });
            }}
          />
        ),
      )}
    </div>
  );
}
